import * as React from 'react';

import { Wrapper } from './styles';

const Spinner = () => (
	<Wrapper>
		{Array.from({ length: 12 }, (v, i) => i + 1).map(i => <div key={i} />)}
	</Wrapper>
);

export default Spinner;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Spinner/index.tsx